import { ArrowRight, CalendarDays, Megaphone, Users, Cake, UserPlus, ArrowLeftRight, Trophy, Eye, Calendar, Quote, ShieldAlert, ShoppingCart, Palette, Briefcase } from "lucide-react";
import { fileUrl } from "@/components/PhotoUploader";
import Avatar from "@/components/Avatar";

export const CAT_STYLE = {
  Groupe: "bg-[#e0e9ff] text-[#1d4ed8]", Commerce: "bg-[#dcfce7] text-[#15803d]", RH: "bg-[#ede9fe] text-[#6d28d9]",
  Marketing: "bg-[#fce7f3] text-[#be185d]", Réseau: "bg-[#ffedd5] text-[#c2410c]", Direction: "bg-[#0b1b3a] text-white",
  Info: "bg-slate-100 text-slate-700", "Vie d'entreprise": "bg-[#e0f2fe] text-[#0369a1]",
  Achats: "bg-[#dcfce7] text-[#15803d]", Com: "bg-[#fce7f3] text-[#be185d]", Qualité: "bg-[#fef3c7] text-[#b45309]",
};
const SERVICE_ICON = { RH: [Briefcase, "bg-[#ede9fe] text-[#6d28d9]"], Achats: [ShoppingCart, "bg-[#dcfce7] text-[#15803d]"], Com: [Palette, "bg-[#fce7f3] text-[#be185d]"], Qualité: [ShieldAlert, "bg-[#fef3c7] text-[#b45309]"] };
const TEAM_ICON = { anniversaire: [Cake, "bg-[#fce7f3] text-[#be185d]"], nouveau: [UserPlus, "bg-[#e0e9ff] text-[#1d4ed8]"], mobilite: [ArrowLeftRight, "bg-[#dcfce7] text-[#15803d]"], bravo: [Trophy, "bg-[#ffedd5] text-[#c2410c]"] };

export const cover = (u) => (!u ? null : u.startsWith("/") || u.startsWith("http") ? u : fileUrl(u));
export const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "";
export function relTime(iso) {
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const h = Math.floor(diff / 3600000);
  if (h < 1) return "à l'instant";
  if (h < 24) return `il y a ${h}h`;
  const d = Math.floor(h / 24);
  return `il y a ${d} jour${d > 1 ? "s" : ""}`;
}

export function Badge({ label, className = "" }) {
  return <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide ${CAT_STYLE[label] || "bg-slate-100 text-slate-600"} ${className}`}>{label}</span>;
}

export function SectionHead({ icon: Icon, title, linkLabel = "Voir tout", onLink, testid }) {
  return (
    <div className="flex items-center justify-between mb-3 gap-2">
      <h2 className="flex items-center gap-2 text-base md:text-lg font-bold text-[#0b1b3a] min-w-0"><Icon className="w-5 h-5 text-[#1d4ed8] shrink-0"/><span className="truncate">{title}</span></h2>
      {onLink && <button onClick={onLink} data-testid={testid} className="text-xs font-semibold text-[#1d4ed8] hover:underline flex items-center gap-1">{linkLabel} <ArrowRight className="w-3.5 h-3.5"/></button>}
    </div>
  );
}

export function ALaUne({ news = [], vision, headcount, onOpen, onAll }) {
  const [main, ...rest] = news;
  return (
    <section data-testid="intranet-alaune">
      <SectionHead icon={Megaphone} title="À la une" linkLabel="Voir toutes les actualités" onLink={onAll} testid="intranet-alaune-all"/>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-9 grid grid-cols-1 md:grid-cols-2 gap-4">
          {main ? (
            <button onClick={() => onOpen(main)} data-testid={`news-main-${main.id}`} className="group text-left bg-white border border-slate-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow">
              <div className="aspect-[16/10] bg-slate-100 overflow-hidden">
                {cover(main.cover_url) && <img src={cover(main.cover_url)} alt="" className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"/>}
              </div>
              <div className="p-4">
                {main.category && <Badge label={main.category}/>}
                <h3 className="mt-2 text-lg font-bold text-[#0b1b3a] leading-snug">{main.title}</h3>
                {main.summary && <p className="mt-1 text-sm text-slate-500 line-clamp-2">{main.summary}</p>}
                <div className="mt-3 flex items-center gap-4 text-xs text-slate-400">
                  <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5"/>{fmtDate(main.created_at)}</span>
                  <span className="flex items-center gap-1" data-testid={`news-views-${main.id}`}><Eye className="w-3.5 h-3.5"/>{main.views || 0}</span>
                  <ArrowRight className="ml-auto w-4 h-4 text-[#1d4ed8]"/>
                </div>
              </div>
            </button>
          ) : <EmptyCard text="Aucune actualité publiée."/>}
          <div className="flex flex-col gap-3">
            {rest.slice(0, 3).map(n => (
              <button key={n.id} onClick={() => onOpen(n)} data-testid={`news-side-${n.id}`} className="group text-left flex gap-3 bg-white border border-slate-200 rounded-lg p-3 hover:shadow-md transition-shadow flex-1">
                <div className="w-20 h-20 rounded-md bg-slate-100 overflow-hidden shrink-0">
                  {cover(n.cover_url) && <img src={cover(n.cover_url)} alt="" className="w-full h-full object-cover"/>}
                </div>
                <div className="min-w-0 flex-1">
                  {n.category && <Badge label={n.category}/>}
                  <div className="mt-1 text-sm font-bold text-[#0b1b3a] leading-snug line-clamp-2">{n.title}</div>
                  {n.summary && <div className="text-xs text-slate-500 line-clamp-1">{n.summary}</div>}
                  <div className="mt-1 text-[11px] text-slate-400 flex items-center gap-1"><Calendar className="w-3 h-3"/>{fmtDate(n.created_at)}</div>
                </div>
                <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-[#1d4ed8] self-center"/>
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-3 flex flex-col gap-4">
          <div className="rounded-lg p-5 border border-[#c7d7fe]" style={{ background: "linear-gradient(160deg,#eef2ff 0%,#dbeafe 100%)" }} data-testid="intranet-vision">
            <div className="text-xs font-bold text-[#0b1b3a]">Notre vision</div>
            <Quote className="w-6 h-6 text-[#1d4ed8] mt-2"/>
            <p className="mt-1 text-base font-semibold italic text-[#0b1b3a] leading-snug">{vision?.text}</p>
            <div className="mt-3 text-xs text-slate-500">— {vision?.author}</div>
          </div>
          <div className="rounded-lg p-5 text-white flex-1" style={{ background: "#0b1b3a" }} data-testid="intranet-headcount">
            <div className="flex items-start justify-between">
              <div className="text-sm text-slate-300">Aujourd'hui,</div>
              <Users className="w-7 h-7 text-[#60a5fa]"/>
            </div>
            <div className="text-4xl font-black mt-1" data-testid="intranet-headcount-value">{headcount ?? "—"}</div>
            <div className="text-sm font-semibold">collaborateurs sur le terrain</div>
            <div className="mt-3 text-xs text-slate-400">Bonne journée à toutes et tous !</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function EmptyCard({ text }) { return <div className="bg-white border border-slate-200 rounded-lg p-8 text-center text-sm text-slate-400">{text}</div>; }

function Card({ children, testid }) { return <div className="bg-white border border-slate-200 rounded-lg p-4 h-full flex flex-col" data-testid={testid}>{children}</div>; }

const MONTHS = ["JANV.", "FÉV.", "MARS", "AVR.", "MAI", "JUIN", "JUIL.", "AOÛT", "SEPT.", "OCT.", "NOV.", "DÉC."];

export function EventsBlock({ events = [], onAll }) {
  return (
    <Card testid="intranet-events">
      <SectionHead icon={CalendarDays} title="Prochains événements" onLink={onAll} testid="intranet-events-all"/>
      <div className="divide-y divide-slate-100">
        {events.length === 0 && <div className="py-6 text-sm text-slate-400 text-center">Aucun événement à venir.</div>}
        {events.map(e => {
          const d = new Date(e.date + "T00:00:00");
          return (
            <div key={e.id} className="flex items-start gap-3 py-3" data-testid={`event-${e.id}`}>
              <div className="w-12 text-center shrink-0">
                <div className="text-2xl font-black text-[#0b1b3a] leading-none">{d.getDate()}</div>
                <div className="text-[10px] font-bold text-slate-400">{MONTHS[d.getMonth()]}</div>
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-bold text-[#0b1b3a] leading-snug">{e.title}</div>
                {(e.summary || e.location) && <div className="text-xs text-slate-500 truncate">{e.summary || e.location}</div>}
              </div>
              <div className="text-right shrink-0">
                {e.time && <div className="text-[11px] text-slate-500 whitespace-nowrap">{e.time}</div>}
                {e.category && <Badge label={e.category} className="mt-1"/>}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export function CommsBlock({ comms = [], onAll }) {
  return (
    <Card testid="intranet-comms">
      <SectionHead icon={Megaphone} title="Communications importantes" onLink={onAll} testid="intranet-comms-all"/>
      <div className="divide-y divide-slate-100">
        {comms.length === 0 && <div className="py-6 text-sm text-slate-400 text-center">Aucune communication.</div>}
        {comms.map(c => {
          const [Icon, tone] = SERVICE_ICON[c.service] || [Megaphone, "bg-slate-100 text-slate-600"];
          return (
            <div key={c.id} className="flex items-start gap-3 py-3" data-testid={`comm-${c.id}`}>
              <div className={`w-9 h-9 rounded-lg grid place-items-center shrink-0 ${tone}`}><Icon className="w-4 h-4"/></div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-bold text-[#0b1b3a] leading-snug">{c.title}</div>
                {c.summary && <div className="text-xs text-slate-500 line-clamp-1">{c.summary}</div>}
                <div className="text-[11px] text-slate-400 mt-0.5">{relTime(c.created_at)}</div>
              </div>
              {c.service && <Badge label={c.service}/>}
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export function TeamBlock({ team = [], onAll }) {
  return (
    <Card testid="intranet-team">
      <SectionHead icon={Users} title="Vie de l'équipe" onLink={onAll} testid="intranet-team-all"/>
      <div className="divide-y divide-slate-100">
        {team.length === 0 && <div className="py-6 text-sm text-slate-400 text-center">Rien à signaler cette semaine.</div>}
        {team.map(t => {
          const [Icon, tone] = TEAM_ICON[t.category] || [Users, "bg-slate-100 text-slate-600"];
          const ppl = t.people_detail || [];
          return (
            <div key={t.id} className="flex items-center gap-3 py-3" data-testid={`team-${t.id}`}>
              <div className={`w-9 h-9 rounded-lg grid place-items-center shrink-0 ${tone}`}><Icon className="w-4 h-4"/></div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-bold text-[#0b1b3a] leading-snug">{t.title}</div>
                {t.summary && <div className="text-xs text-slate-500 line-clamp-1">{t.summary}</div>}
              </div>
              {ppl.length > 0 && (
                <div className="flex -space-x-2 shrink-0">
                  {ppl.slice(0, 3).map(u => <div key={u.id} className="ring-2 ring-white rounded-full"><Avatar user={u} size={28}/></div>)}
                  {ppl.length > 3 && <div className="w-7 h-7 rounded-full bg-slate-100 text-slate-600 text-[10px] font-bold grid place-items-center ring-2 ring-white">+{ppl.length - 3}</div>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
